import { BaseQueryFn } from "@reduxjs/toolkit/query";
import axiosInstance from "./api";
import { AxiosError, InternalAxiosRequestConfig } from "axios";

export interface ApiErrorResponse {
  detail: string;
  status: number;
  title: string;
  /** Machine-readable reason, where the endpoint sets one (e.g. QUIET_HOURS_CONFIRM_REQUIRED). */
  code?: string;
}

export interface ApiError {
  detail?: string;
  title?: string;
  status?: number;
  code?: string;
  /** The untouched error body, for endpoints that attach structured detail beyond `code`. */
  data?: unknown;
}

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" },
  ): BaseQueryFn<
    {
      url: string;
      method: InternalAxiosRequestConfig["method"];
      data?: InternalAxiosRequestConfig["data"];
      params?: InternalAxiosRequestConfig["params"];
      headers?: InternalAxiosRequestConfig["headers"];
      timeout?: number;
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, params, headers, timeout }) => {
    try {
      const response = await axiosInstance({
        url: baseUrl + url,
        method,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        data,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        params,
        headers,
        timeout: timeout ?? 10000,
      });

      return response.data ? response.data : { data: null };
    } catch (axiosError) {
      const error = axiosError as AxiosError<ApiErrorResponse>;
      console.log(axiosError);
      return {
        error: {
          detail: error.response?.data?.detail,
          title: error.response?.data?.title,
          status: error.response?.data?.status ?? error.response?.status,
          code: error.response?.data?.code,
          data: error.response?.data,
        } satisfies ApiError,
      };
    }
  };

export default axiosBaseQuery;
